import React from "react";
import { Award, Flame, ShieldCheck } from "lucide-react";
import { certifications } from "../mock";

const iconMap = { Award, Flame, ShieldCheck };

export default function Certifications() {
  return (
    <section className="bg-white py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <p className="text-[11px] tracking-[0.3em] text-orange-600 font-semibold uppercase">Trusted Quality</p>
          <h2 className="font-display text-3xl md:text-5xl font-bold mt-3 uppercase">Our Certifications</h2>
          <span className="block w-24 h-[3px] bg-orange-500 mx-auto mt-4" />
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {certifications.map((c, i) => {
            const Icon = iconMap[c.icon] || Award;
            return (
              <div key={i} className="lift-on-hover bg-white border border-neutral-200 rounded-xl p-7 text-center">
                <div className="w-16 h-16 mx-auto rounded-full bg-orange-500 text-white flex items-center justify-center shadow-md">
                  <Icon size={26} />
                </div>
                <h4 className="font-display text-xl mt-5 uppercase">{c.title}</h4>
                <p className="text-sm text-neutral-500 mt-1">{c.subtitle}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
